// ------------------------------- //
//  Next Paint                     //
// ------------------------------- //

// resolves AFTER the browser paints the current frame — lets optimistic UI render before heavy sync work

export const nextPaint = (): Promise<void> =>
  new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)))
